import { Key } from '@ms/items-view/lib/private/models/KeyFacet';
import { spFolderItemSetKeyFacet } from '../dataSource/Keys';
import { IItemCacheThunkAction, IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { sharePointAddonDataOnly } from '../dataSource/SpAddonDataOnly';
import { getItems } from '@ms/items-view/lib/private/operations/getItems';
import { pack } from '@ms/items-view/lib/private/models/Facet';
import { displayNameFacet } from '@ms/items-view/lib/private/facets/ItemFacets';
import { childItemsFacet } from '@ms/items-view/lib/private/facets/SetFacets';

/**
 * Creates an action which, when dispatched, pre-fetches data for a given item set key,
 * ensuring that the item data is resolved into the item cache.
 * @beta
 */
export function prefetchSpFolderItemSet(payload: {
  itemKey: Key<typeof spFolderItemSetKeyFacet.type>;
}): IItemCacheThunkAction<Promise<void>> {
  const {
    itemKey
  } = payload;

  return async (dispatch: IItemCacheDispatch) => {
    // TODO Factor out a very-reduced add-on for this critical path only.
    dispatch(sharePointAddonDataOnly);

    return await dispatch(getItems({
      items: {
        [itemKey]: {
          demands: {
            ...pack({}, {}),
            [childItemsFacet.id]: true,
            [displayNameFacet.id]: true
          }
        }
      }
    }));
  };
}
